import classNames from 'classnames'
import { ElementType, FC, Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { Body2, Title1 } from '@ui/Typography'
import { ArrowIcon } from '@ui/icons/Arrow.icon'

import { Box } from '@shared/components/Box'

import styles from './Steps.module.scss'

export interface StepItem {
  title?: string
  icon: ElementType
  label?: string
}

interface StepsProps {
  firstStep?: StepItem
  nextStep?: StepItem
  finalStep?: StepItem
}

export const Steps: FC<StepsProps> = (props) => {
  const { firstStep, nextStep, finalStep } = props

  const { t } = useTranslation()

  const hasAllSteps = firstStep && nextStep && finalStep

  const getTitleByIndex = (index: number) => {
    switch (index) {
      case 0:
        return t('IB.Dashboard.Current level')
      case 1:
        return t('IB.Dashboard.Next level')
      case 2:
        return t('IB.Dashboard.Final level')
      default:
        return ''
    }
  }

  return (
    <div
      className={classNames(styles.steps, {
        [styles.center]: !hasAllSteps,
      })}
    >
      {[firstStep, nextStep, finalStep].map((step, index) => {
        if (!step) {
          return null
        }

        return (
          <Fragment key={index}>
            <Step
              title={step.title ?? getTitleByIndex(index)}
              icon={step.icon}
              label={step.label}
            />
            {index < 2 && (
              <Box mt='x32'>
                <ArrowIcon.Right color={index === 0 ? 'text-med-em' : 'text-base-em'} />
              </Box>
            )}
          </Fragment>
        )
      })}
    </div>
  )
}

const Step: FC<StepItem> = (props) => {
  const { title, icon: Icon, label } = props

  return (
    <div className={styles.step}>
      {!!title?.length && <Body2 className={styles.stepTitle}>{title}</Body2>}
      <Icon />
      {!!label?.length && (
        <Title1 title={label} className={styles.stepLabel}>
          {label}
        </Title1>
      )}
    </div>
  )
}
